import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import useSWR from "swr";

import { useCallback } from "react";

import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";

import { SKSpinner } from "components/customElements/skSpinner";
import FontAwesomeIcon from "components/FontAwesomeIcon";
import TopNavBarMobile from "components/TopNavBar/TopNavBarMobile";
import useMediaQuery from "hooks/useMediaQuery";
import { ApiEndpoint, baseFetcher } from "utils/baseFetcher";

import styles from "./style.module.scss";

const Modal = dynamic(() => import("react-modal"));

export const presentationUrl = (id: string | number) => {
  const url = new ApiEndpoint(`/api/v2/corporate-presentations/${id}`);
  url.searchParams.append("include", "entity,corporate-attachments");

  return url.href;
};

type PresentationModalProps = {
  id: number | string;
  selectedItem?: any;
};

const PresentationModal = ({ id, selectedItem }: PresentationModalProps) => {
  const router = useRouter();
  const { mobile } = useMediaQuery();

  const { data, isValidating } = useSWR(presentationUrl(id), baseFetcher);

  const item = selectedItem || data;

  const firstUrl =
    item?.attachment?.[0] || item?.corporateAttachments?.[0]?.source;

  const toggleModal = useCallback(() => {
    if (router.query.slug) {
      router.push(
        `/entities/${router.query.slug}/announcements?tab=presentations`
      );
    } else {
      router.back();
    }
  }, [router]);

  return (
    <Modal
      portalClassName={styles.modal}
      overlayClassName={styles.overlay}
      className={styles.content}
      isOpen
    >
      {mobile ? (
        <TopNavBarMobile onGoBack={toggleModal} />
      ) : (
        <div className={styles.actionsBar}>
          <FontAwesomeIcon
            icon={faTimes}
            className={styles.closeButton}
            onClick={toggleModal}
          />
        </div>
      )}
      {firstUrl ? (
        <iframe
          className={styles.iframe}
          src={`${firstUrl}${mobile ? "#zoom=1" : "#zoom=FitW"}`}
        />
      ) : (
        isValidating && <SKSpinner />
      )}
    </Modal>
  );
};

export default PresentationModal;
